import React, { useEffect, useState } from "react";
import { Box, Text, useColorModeValue ,Menu,MenuButton,MenuList,Flex } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { currencyFormate } from "jsFunctions/helperFunctions";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { FaEllipsisV } from "react-icons/fa";
import { CiExport } from "react-icons/ci";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import RecordTable from "./RecordTable/RecordTable";
import { InvoiceNumberFormate } from "jsFunctions/helperFunctions";
import { gstRecordColumns } from "./RecordTable/ColumnData";
import { fetchAsyncSearchGstRecords } from "redux/invoicePaymentRecordSlice";
import InvoiceGstInfoModel from "components/models/invoiceGstInfoModel";
import ExportDataModel from "components/exportData/ExportDataModel";

const InvoiceGstRecords = () => {
  const [gstRecordData, setGstRecordData] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [openGstInfoModel, setOpenGstInfoModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const currUser = useSelector((state) => state.auth.currUser);
  const [role,setRole] = useState('')  

  useEffect(()=>{
    if(currUser && currUser?.auth){
      const auth = currUser?.auth;
      const roleObj = auth && auth?.length > 0 && auth.find((item)=> item?.module === 'Invoice GST');
      if(roleObj){
        setRole(roleObj?.access)
      }
    }
  },[currUser])

  const gstRecords = useSelector((state) => state.gstRecords);
  const dispatch = useDispatch();
 
  useEffect(() => {
    setLoading(true); 
    dispatch(fetchAsyncSearchGstRecords({}))
      .then(() => {
        setLoading(false); 
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false); 
      });
  }, []);

  useEffect(() => {
    if (gstRecords?.recordsData && gstRecords?.recordsData.length > 0) {
      const tableData = gstRecords?.recordsData.map((record, index) => {
        const totalGst = (record?.amt?.i ?? 0) + (record?.amt?.s ?? 0) + (record?.amt?.c ?? 0);        
        return {
          _id:record._id,
          no: index + 1,
          inNo: (
            <span 
              style={{ cursor: "pointer",color:'blue'}}
            >
              {record?.inId ? InvoiceNumberFormate(record?.inId?.inNo) : "-"}
            </span>
          ),
          client: <span>{record?.cId?.clName || "-"}</span> ,
          gstNumber: record?.gstNo,
          sortBaseAmt:record?.bsAmt || 0,
          baseAmount:(
            <span>
              {record?.bsAmt ? currencyFormate(record?.bsAmt ): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
            </span>
          ),
          sortIgstAmt:Number(record?.amt?.i || 0),
          igstAmt: (
            <span>
              {record?.amt?.i ? currencyFormate(record?.amt?.i ): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
            </span>
          ),
          sortSgstAmt:Number(record?.amt?.s || 0),
          sgstAmt: (
            <span>
              {record?.amt?.s ? currencyFormate(record?.amt?.s ): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
            </span>
          ),
          sortCgstAmt:Number(record?.amt?.c || 0),
          cgstAmt: (
            <span>
              {record?.amt?.c ? currencyFormate(record?.amt?.c): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
            </span>
          ),
          sortTlAmt:Number(totalGst),
          totalGst: (
            <span className="f-600 green">
              {totalGst ? currencyFormate(totalGst): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
            </span>
          ),
          invoiceDate: dateTimeFormat(record?.inId?.inDt),
        };
      });
      setGstRecordData(tableData);
    } else {
      setGstRecordData([]);
    }
  }, [gstRecords]);

  const handleRowClick = (e,_id)=>{
    e.stopPropagation();
    const recordData = gstRecords?.recordsData || [];
    const data = recordData.filter((item)=> item?._id === _id)
    setSelectedItem(data[0]);
    setOpenGstInfoModel(true);
  }

  const closeGstInfoModel = () => {
    setOpenGstInfoModel(false);
    setSelectedItem({});
  };
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  let menuBg = useColorModeValue("white", "navy.800");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const [isOpen, setIsOpen] = useState(false);
  const [activeBtn,setActiveBtn] = useState("")

  const toggleMenu = (btn) => {
    setIsOpen(!isOpen);
    setActiveBtn(btn)
  };
  const handleClose = () => {   
    setActiveBtn("");   
    setIsOpen(false)
  };

  if (loading) {
    return (
      <SpinnerLoader/>
    );
  }
  return (
    <>
       <Box  display="flex" className="mx-3" justifyContent="space-between">
       <Box display="flex">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
          mt={5}
        >
          Invoice GST
        </Text>
        </Box>
        <Box display="flex" mt={2} className="add-new-btn">
        <Box>
          <Menu>
          <MenuButton p="0px">
          <Box  className='menu-ellipsis-btn'><FaEllipsisV /></Box>

          </MenuButton>
          <MenuList
             boxShadow={shadow}
             p="0px"
             mt="10px"
             borderRadius="10px"
             bg={menuBg}
             border="none"
          >
            <Flex w="100%" mb="0px" flexDirection="column">
            <Box
                ps="20px"
                pt="10px"
                pb="8px"
                className="menu-text"
                borderBottom="1px solid gray"
                borderColor={borderColor}
                onClick={()=>toggleMenu('xlsx')}
                display="flex"
              >
                <CiExport size={20} className="mx-1"/> <span>Export XLSX</span>
              </Box>
            </Flex>
            <Flex w="100%" mb="0px" flexDirection="column">
            
            </Flex>
           <Box marginRight={40}>
           {isOpen && (
            <ExportDataModel
              filename={"Invoice GST_"}
              type="invoiceGst"
              role={role}
              isOpen={isOpen}
              handleClose={handleClose}
              activeBtn={activeBtn}
            />
          )}
           </Box>
          </MenuList>
        </Menu>
          </Box>
        </Box>
      </Box>
      <Box pt={{ base: "40px", md: "10px", xl: "10px" }}>
        <RecordTable
          columnsData={gstRecordColumns}
          tableData={gstRecordData}
          type={"Invoice GST"}
          role={role}
          gstRecords={gstRecords}
          expenseType = 'Invoice GST'
          openInfoModal = {handleRowClick}
        />
      </Box>
      {openGstInfoModel && (
        <InvoiceGstInfoModel
          openInfoModal={openGstInfoModel}
          closeInfoModal={closeGstInfoModel}
          selectedItem={selectedItem}   
          role={role}
     
        />
      )}
    </>
  );
};

export default InvoiceGstRecords;
